"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _icon = _interopRequireDefault(require("../icon"));

var _cell = _interopRequireDefault(require("../mixins/cell"));

var _routerLink = _interopRequireDefault(require("../mixins/router-link"));

var _createBasic = _interopRequireDefault(require("../utils/create-basic"));

var _default = (0, _createBasic.default)({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: [_vm.b((_obj = {
        center: _vm.center,
        required: _vm.required,
        borderless: !_vm.border,
        clickable: _vm.isLink || _vm.clickable
      }, _obj[_vm.size] = _vm.size, _obj))],
      on: {
        "click": _vm.onClick
      }
    }, [_vm._t("icon", [_vm.icon ? _c('icon', {
      class: _vm.b('left-icon'),
      attrs: {
        "name": _vm.icon
      }
    }) : _vm._e()]), _vm.isDef(_vm.title) || _vm.$slots.title ? _c('div', {
      class: [_vm.b('title'), _vm.titleClass]
    }, [_vm._t("title", [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.title)
      }
    }), _vm.label ? _c('div', {
      class: [_vm.b('label'), _vm.labelClass],
      domProps: {
        "textContent": _vm._s(_vm.label)
      }
    }) : _vm._e()])], 2) : _vm._e(), _vm.isDef(_vm.value) || _vm.$slots.default ? _c('div', {
      class: [_vm.b('value', {
        alone: !_vm.$slots.title && !_vm.title
      }), _vm.valueClass]
    }, [_vm._t("default", [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.value)
      }
    })])], 2) : _vm._e(), _vm._t("right-icon", [_vm.isLink ? _c('icon', {
      class: _vm.b('right-icon'),
      attrs: {
        "name": _vm.arrowIcon
      }
    }) : _vm._e()]), _vm._t("extra")], 2);

    var _obj;
  },
  name: 'cell',
  components: {
    Icon: _icon.default
  },
  mixins: [_cell.default, _routerLink.default],
  props: {
    size: String,
    clickable: Boolean,
    arrowDirection: String
  },
  computed: {
    arrowIcon: function arrowIcon() {
      return this.arrowDirection ? "arrow-" + this.arrowDirection : 'arrow';
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click');
      this.routerLink();
    }
  }
});

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/cell/index.js
// module id = 243
// module chunks = 1